import { Routes, RouterModule, } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { AdminModule } from './admin/admin.module';
import { CanActivateViaAuthGuard } from './services/authguard.service';

//import { AboutComponent } from './about/about.component';

//const adminRoutes: Routes = [
//    {
//        path: 'admin',

//        loadChildren: './app/admin/admin.module#AdminModule'
//        //canLoad: [AuthGuard]
//    }
//];

//export function loadCrisisCenter() {
//    return require('es6-promise!./admin/admin.module')('AdminModule');
//}

const appRoutes: Routes = [
    {
        path: '',// redirectTo: 'home', pathMatch: 'full',
        component: HomeComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    //{ path: '**', component: PageNotFoundComponent }
    {
        path: 'home', component: HomeComponent,
        canActivate: [CanActivateViaAuthGuard]
    },

    //{ path: 'admin', loadChildren: './app/admin/admin.module#AdminModule' }

    //{
    //    path: 'admin', loadChildren: () =>
    //        new Promise(resolve =>
    //            (require as any).ensure([], () =>
    //                resolve(require('./admin/admin.module').AdminModule)
    //            ))
    //}

    {
        path: 'admin',
        loadChildren: () => new Promise(function (resolve) {
            (require as any).ensure([], function (require: any) {
                resolve(require('./admin/admin.module')['AdminModule']);
            });
        })
    },

//        {
//            //path: 'admin',
////            loadChildren: loadCrisisCenter
//        path: 'admin', loadChildren: './admin/admin.module#AdminModule'
//            //loadChildren: loadCrisisCenter// () => require("es6-promise!./admin/admin.module")("AdminModule")

//    }

    //{ path: 'admin', component: AdminComponent }
    //{ path: 'about', component: AboutComponent }
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./app/app.routes.ts